// extracted by mini-css-extract-plugin
export default {"container":"HeaderBadges_container__hYhWY"};